import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id E1BE2EC4-D5D5-475C-A562-9855DA1612FB
 * name set-left-right
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-left-right.svg
 * tags
 * - Database 
 */
export const SetLeftRightIcon = createSvgIcon(<><path d="M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5A7,7 0 0,1 22,12A7,7 0 0,1 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19A7,7 0 0,1 2,12A7,7 0 0,1 9,5M9,12C9,14.22 10.21,16.16 12,17.2C13.79,16.16 15,14.22 15,12C15,9.78 13.79,7.84 12,6.8C10.21,7.84 9,9.78 9,12Z" /></>, 'SetLeftRightIcon');
export default SetLeftRightIcon